import React from "react";
import { Form } from "antd";
import Input from "./BaseInput";
import AutoDismissToolTip from "@/components/AutoDismissToolTip";

interface SkuPropertiesFieldProps {}

const SkuPropertiesField: React.FC<SkuPropertiesFieldProps> = function (props) {
    return (
        <AutoDismissToolTip
            title={
                <a
                    href="https://qw15p3s8hv.feishu.cn/wiki/wikcnopJitfHQXPC15NtGRAxN9c"
                    target="_blank"
                    className="text-white"
                >
                    支持搜索包含多个属性商品的订单，用&分隔，如：红色&XL 点击这里查看详细介绍
                </a>
            }
        >
            <Form.Item label={<span className="search-field-label">商品属性</span>} name="skuProperties">
                <Input />
            </Form.Item>
        </AutoDismissToolTip>
    );
};

export default React.memo(SkuPropertiesField);
